import { useFeatureFlags } from "@/contexts/FeatureFlagsContext";
import { useAppSettings } from "@/hooks/useAppSettings";

const DEFAULT_LOGO = "/lovable-uploads/northwind-mark.png";
const DEFAULT_LOGO_SVG = "/lovable-uploads/northwind-mark.png";

export const useLogo = () => {
  const { flags, isLoading: isFlagsLoading } = useFeatureFlags();
  const { settings, isLoading: isSettingsLoading } = useAppSettings();

  const isLoading = isFlagsLoading || isSettingsLoading;
  const isDemoMode = flags.demoMode;
  const demoLogoUrl = settings.demo_logo_url;

  // Return demo logo if demo mode is enabled and a demo logo exists
  const logoUrl = isDemoMode && demoLogoUrl ? demoLogoUrl : DEFAULT_LOGO;
  const logoSvgUrl = isDemoMode && demoLogoUrl ? demoLogoUrl : DEFAULT_LOGO_SVG;

  return {
    logoUrl,
    logoSvgUrl,
    isDemoMode,
    isLoading,
    DEFAULT_LOGO,
    DEFAULT_LOGO_SVG,
  };
};
